import palette from '../../theme/palette';

export default theme => ({
  root: ({ isMailproInsights } = {}) => ({
    position: 'fixed',
    // Raised above the LGPromptX chat launcher (60px circle at right: 20px, bottom: ~20px -
    // see SessionSwitchFABV2's own note on the same launcher) instead of the default bottom spacing.
    bottom: isMailproInsights ? '112px' : theme.spacing(3),
    right: isMailproInsights ? '27px' : theme.spacing(2),
    zIndex: isMailproInsights ? 1200 : 3,
    '& .MuiFab-root': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    }
  }),
  rootLeft: ({ isMailproInsights } = {}) => ({
    position: 'fixed',
    bottom: theme.spacing(3),
    left: theme.spacing(2),
    zIndex: isMailproInsights ? 1200 : 3,
    // The persistent left sidebar (Dashboard layout) is 271px wide with
    // zIndex 2500 on lg+ screens — left: 16px sits underneath it, hiding
    // this button entirely. Push past the sidebar on those screens.
    [theme.breakpoints.up('lg')]: {
      left: '287px',
    },
    '& .MuiFab-root': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    }
  }),
  rootForP1: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(9),
    '& .MuiFab-root': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    }
  },
  rootForP2: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(16),
    '& .MuiFab-root': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    }
  },
});
